import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ContextSources } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateContextSourcesGetKey } from '~/components/v2/hooks/queries/usePrivateContextSourcesGet';
import { getPrivateContextSourcesListKey } from '~/components/v2/hooks/queries/usePrivateContextSourcesList';

export type UsePrivateContextSourcesAddValueMutationParams = NonNullable<
  Parameters<typeof ContextSources.Fields.Values.create>[0]
>;

export const usePrivateContextSourcesAddValueMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateContextSourcesAddValueMutationParams) => {
      return callAirApi(() => ContextSources.Fields.Values.create(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        error,
        context: 'Failed to add context source value',
        metadata: {
          key: 'data',
          data: variables,
        },
      });
    },

    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: getPrivateContextSourcesGetKey({
          contextSourceId: variables.contextSourceId,
          workspaceId: variables.workspaceId,
        }),
      });
      queryClient.invalidateQueries({
        queryKey: getPrivateContextSourcesListKey({
          workspaceId: variables.workspaceId,
        }),
      });
    },
  });
};
